import * as constants from '../constants';

export interface DataState {
  formData: {
    name: string;
    email: string;
    message: string;
  };
  formErrors: { [key: string]: boolean };
  contentLoading?: boolean;
  marketContent: { [key: string]: any };
}

const initialState: DataState = {
  formData: { name: '', email: '', message: '' },
  formErrors: {},
  contentLoading: false,
  marketContent: {}
};

const dataReducer = (state = initialState, action: { type: string; payload?: any }) => {
  switch (action.type) {
    case constants.SET_FORM_DATA:
      return { ...state, formData: action.payload.data };
    case constants.SET_FORM_ERRORS:
      return {
        ...state,
        formErrors: action.payload.errors
      };
    case constants.SET_MARKET_CONTENT:
      return {
        ...state,
        marketContent: action.payload.content
      };
    default:
      return state;
  }
};

export { dataReducer };
